import { aboutData } from '@/mocks/homeData';

export default function AboutSection() {
  return (
    <section id="about" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <p className="text-xs font-semibold text-primary-500 uppercase tracking-wider mb-2">ABOUT US</p>
          <h2 className="font-heading text-2xl md:text-4xl text-foreground-900">{aboutData.title}</h2>
        </div>

        <div className="max-w-3xl mx-auto">
          <div className="bg-background-100 rounded-2xl border border-background-200/70 p-6 md:p-10">
            {aboutData.paragraphs.map((p, i) => (
              <p key={i} className="text-sm text-foreground-700 leading-relaxed mb-4 last:mb-0">{p}</p>
            ))}
          </div>

          <div className="grid grid-cols-2 md:grid-cols-4 gap-4 mt-8">
            {aboutData.stats.map((stat) => (
              <div key={stat.label} className="text-center p-5 bg-background-100 rounded-xl border border-background-200/70">
                <div className="text-2xl md:text-3xl font-bold text-primary-500 mb-1">{stat.value}</div>
                <div className="text-xs text-foreground-500">{stat.label}</div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}